import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Table } from "../../../../../components/ui/Table";

const TableErrorPartners = (props) => {
  const { data } = props;
  const COLUMNS = useMemo(() => {
    if (!data.length) {
      return [];
    }

    return [
      {
        Header: "Fecha",
        accessor: "dt_report",
      },
      {
        Header: "Teléfono",
        accessor: "vc_msisdn",
      },
      {
        Header: "Mensaje",
        accessor: "vc_mensaje",
      },
      {
        Header: "Código de Respuesta",
        accessor: "vc_codigorespuesta",
      },
      {
        Header: "Respuesta",
        accessor: "vc_respuesta",
      },
    ];
  }, [data]);

  return (
    <Table
      columns={COLUMNS}
      data={data}
      config={{
        search: true,
        footer: true,
        printfooter: true,
        pageSize: 10,
        perPage: 10,
        export: true,
      }}
    />
  );
};

TableErrorPartners.propTypes = {
  data: PropTypes.array,
};

export default TableErrorPartners;
